module.exports = __webpack_public_path__ + "assets/img/Future_001.355e3c07-ps.jpg";